import { configureStore } from '@reduxjs/toolkit'
import navReducer from './navSlice'
import toastReducer from './toastSlice'
import userReducer from './userSlice'

const store = configureStore({
    reducer: {
        user: userReducer,
        toast: toastReducer,
        nav: navReducer,
    },
})

export default store
